<!-- the terminal: the tickers on the left, the picked one's price line on the right -->
<div class="aw-terminal">
  <aside class="aw-list">
    <label class="ap-search aw-list-search">
      <span class="sr-only">Search the models</span>
      <input type="search" [ngModel]="query" (ngModelChange)="setQuery( $event )" [placeholder]="compact ? 'Search a model' : 'Search a model, a vendor or a platform'" autocomplete="off" spellcheck="false">
    </label>
    <div class="aw-list-scroll" *ngIf="prices; else listLoading">
      <button type="button" class="aw-ticker" *ngFor="let t of tickers" [class.on]="model === t.id" (click)="pickModel( t.id )" [title]="t.id">
        <img class="ap-picon" [src]="platformIcon( t.platform )" alt="" width="16" height="16">
        <span class="aw-ticker-id">
          <span class="aw-ticker-name">{{ t.name }}</span>
          <span class="aw-ticker-plat">{{ platformLabel( t.platform ) }}</span>
        </span>
        <span class="aw-ticker-quote">
          <span class="aw-ticker-price">{{ price( t.price ) }}</span>
          <span class="aw-pct" [class.down]="t.direction === 'down'" [class.up]="t.direction === 'up'"><span class="aw-arrow" *ngIf="t.direction === 'down' || t.direction === 'up'">{{ t.direction === 'down' ? '▼' : '▲' }}</span>{{ pctLabel( t.pct || 0 ) }}</span>
        </span>
      </button>
      <p class="ap-empty" *ngIf="!tickers.length">No model matches. Try another word</p>
    </div>
    <ng-template #listLoading>
      <div class="aw-list-scroll aw-skeleton" aria-busy="true" aria-label="Loading the models">
        <div class="aw-ticker" *ngFor="let i of skeletonRows">
          <span class="aw-sk aw-sk-dot aw-sk-small"></span>
          <span class="aw-ticker-id"><span class="aw-sk aw-sk-bar" style="width: 70%; height: 13px"></span><span class="aw-sk aw-sk-bar" style="width: 45%; height: 10px; margin-top: 5px"></span></span>
          <span class="aw-ticker-quote"><span class="aw-sk aw-sk-bar" style="width: 46px; height: 13px"></span><span class="aw-sk aw-sk-bar" style="width: 36px; height: 11px; margin-top: 5px"></span></span>
        </div>
      </div>
    </ng-template>
  </aside>

  <div class="aw-right">
  <section class="aw-chart" *ngIf="selected && changes && indexRows.length; else chartLoading" aria-live="polite">
    <div class="aw-settings">
      <div class="aw-settings-row">
        <div class="aw-settings-group">
          <p class="aw-settings-title">Token Price</p>
          <nav class="ap-platforms aw-fields" aria-label="Token price">
            <button type="button" class="pl-chip" *ngFor="let f of fields" [class.on]="field === f.key" (click)="setField( f.key )"><span>{{ f.label }}</span></button>
          </nav>
        </div>
        <div class="aw-settings-group">
          <p class="aw-settings-title">Range</p>
          <nav class="ap-platforms aw-fields" aria-label="Range">
            <button type="button" class="pl-chip" *ngFor="let r of ranges" [class.on]="range === r.key" (click)="setRange( r.key )"><span>{{ r.label }}</span></button>
          </nav>
        </div>
      </div>
      <p class="aw-settings-hint" *ngIf="!compact">{{ fieldHint }}</p>
    </div>
    <header class="aw-chart-head">
      <div class="aw-chart-id">
        <img class="ap-picon" [src]="platformIcon( selected.platform )" alt="" width="20" height="20">
        <div>
          <p class="aw-chart-name">{{ selected.name }}</p>
          <p class="aw-chart-sub">{{ platformLabel( selected.platform ) }} · {{ selected.vendor }}<ng-container *ngIf="selected.deprecation"> · retires {{ selected.deprecation }}</ng-container></p>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="quote"></ng-container>
    </header>

    <ng-container *ngTemplateOutlet="plot"></ng-container>

    <p class="aw-chart-unit"><span class="aw-chart-move" [class.up]="lastMove.startsWith( 'Up' )" [class.down]="lastMove.startsWith( 'Down' )">{{ lastMove }}</span><span>USD per million tokens</span></p>
  </section>
  </div>
</div>

<!-- the tape: models with their prices and their move over the range, running like a ticker -->
<div class="aw-tape" *ngIf="!compact && ticks.length" aria-label="Models and their price move">
  <div class="aw-tape-track">
    <button type="button" class="aw-tick" *ngFor="let t of ticks" [class.on]="model === t.id" (click)="pickModel( t.id )" [title]="t.id">
      <img class="ap-picon" [src]="platformIcon( t.platform )" alt="" width="14" height="14">
      <span class="aw-tick-name">{{ t.name }}</span>
      <span class="aw-tick-price">{{ price( t.price ) }}</span>
      <span class="aw-pct" [class.down]="t.direction === 'down'" [class.up]="t.direction === 'up'"><span class="aw-arrow" *ngIf="t.direction === 'down' || t.direction === 'up'">{{ t.direction === 'down' ? '▼' : '▲' }}</span>{{ pctLabel( t.pct || 0 ) }}</span>
    </button>
    <button type="button" class="aw-tick" *ngFor="let t of ticks" [class.on]="model === t.id" (click)="pickModel( t.id )" aria-hidden="true" tabindex="-1">
      <img class="ap-picon" [src]="platformIcon( t.platform )" alt="" width="14" height="14">
      <span class="aw-tick-name">{{ t.name }}</span>
      <span class="aw-tick-price">{{ price( t.price ) }}</span>
      <span class="aw-pct" [class.down]="t.direction === 'down'" [class.up]="t.direction === 'up'"><span class="aw-arrow" *ngIf="t.direction === 'down' || t.direction === 'up'">{{ t.direction === 'down' ? '▼' : '▲' }}</span>{{ pctLabel( t.pct || 0 ) }}</span>
    </button>
  </div>
</div>


<ng-template #quote>
  <div class="aw-chart-quote">
    <span class="aw-chart-price">{{ price( fieldPrice( selected ) ) }}</span>
    <span class="aw-pct" [class.down]="!!chartPct && chartPct < 0" [class.up]="!!chartPct && chartPct > 0"><span class="aw-arrow" *ngIf="chartPct">{{ chartPct < 0 ? '▼' : '▲' }}</span>{{ pctLabel( chartPct || 0 ) }}</span>
  </div>
</ng-template>

<ng-template #plot>
  <svg class="aw-plot" [attr.viewBox]="'0 0 ' + CHART_W + ' ' + CHART_H" role="img" [attr.aria-label]="selected.name + ' ' + fieldName + ' price per day'"
       (pointermove)="onPlotHover( $event )" (pointerdown)="onPlotHover( $event )" (pointerleave)="hover = null">
    <g class="aw-grid">
      <ng-container *ngFor="let y of chart.yTicks">
        <line [attr.x1]="0" [attr.x2]="CHART_W - CHART_AXIS" [attr.y1]="y.y" [attr.y2]="y.y"/>
        <text [attr.x]="CHART_W - CHART_AXIS + 8" [attr.y]="y.y + 4">{{ y.label }}</text>
      </ng-container>
      <text *ngFor="let x of chart.xTicks" [attr.x]="x.x" [attr.y]="CHART_H - 6" text-anchor="middle">{{ x.label }}</text>
    </g>
    <g *ngIf="chart.line" class="aw-line" [class.down]="!!chartPct && chartPct < 0" [class.up]="!!chartPct && chartPct > 0">
      <line class="aw-base" [attr.x1]="chart.startX" [attr.x2]="CHART_W - CHART_AXIS" [attr.y1]="chart.baseY" [attr.y2]="chart.baseY"/>
      <path class="aw-area" [attr.d]="chart.area"/>
      <path class="aw-stroke" [attr.d]="chart.line"/>
      <!-- the hovered day: a line down to the axis, a dot on the price and the price with its day above it -->
      <g *ngIf="hover as h" class="aw-hover">
        <line [attr.x1]="h.x" [attr.x2]="h.x" [attr.y1]="h.y" [attr.y2]="chart.bottom"/>
        <circle [attr.cx]="h.x" [attr.cy]="h.y" r="4.5"/>
        <g *ngIf="hoverBox() as b" class="aw-hover-label" [attr.transform]="'translate(' + b.x + ',' + b.y + ')'">
          <rect [attr.width]="b.w" [attr.height]="b.h" rx="6"/>
          <text x="10" y="17"><tspan class="aw-hover-price">{{ h.price }}</tspan><tspan dx="8">{{ h.day }}</tspan></text>
          <text *ngIf="h.note" class="aw-hover-note" x="10" y="35">{{ h.note }}</text>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<!-- while the board loads: the chart's silhouette, shimmering -->
<ng-template #chartLoading>
  <section class="aw-chart aw-skeleton" aria-busy="true" aria-label="Loading the chart">
    <header class="aw-chart-head">
      <div class="aw-chart-id">
        <span class="aw-sk aw-sk-dot"></span>
        <div><span class="aw-sk aw-sk-bar" style="width: 160px; height: 20px"></span><span class="aw-sk aw-sk-bar" style="width: 110px; height: 11px; margin-top: 6px"></span></div>
      </div>
      <div class="aw-chart-quote"><span class="aw-sk aw-sk-bar" style="width: 96px; height: 32px"></span><span class="aw-sk aw-sk-bar" style="width: 60px; height: 20px; margin-top: 6px"></span></div>
    </header>
    <div class="aw-sk-plot">
      <span class="aw-sk aw-sk-area" [style.clip-path]="skeletonArea"></span>
    </div>
  </section>
</ng-template>
